import { FocusFieldDirective } from '@games/core/focus';
import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { MathUtils } from '../../utils';
import { MathOperation, MathOperationWritable } from '../math-operation';
import { InputWithCalculatorDirective } from '@games/core/focus/InputWithCalculator';
import { VirtualKeyboardDirective } from '@games/core/input/VirtualKeyboard';

@Component({
  selector: 'ms-math-line',
  templateUrl: './math-line.component.html',
  styleUrls: ['./math-line.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FocusFieldDirective,
    VirtualKeyboardDirective,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MathLineComponent),
      multi: true,
    },
  ],
  hostDirectives: [DimensionsListenerDirective],
})
export class MathLineComponent extends MathOperationWritable {
  readonly valueControl = new FormControl<string>('');

  @Input()
  public get value(): string | number {
    return this._value;
  }

  public set value(value: string | number) {
    if (value === this._value) {
      return;
    }
    this._value = value;
    this.updateViewBox();
    this.valueControl.setValue(value.toString());
  }

  private _value: string | number = '';

  @Input()
  public get useTextInput(): boolean {
    return this._useTextInput;
  }

  public set useTextInput(value: boolean) {
    this._useTextInput = value;
    if (value) {
      this.value = this.valueControl.value;
      this.updateViewBox();
    }
  }

  private _useTextInput: boolean = false;

  constructor() {
    super();
    this.valueControl.valueChanges.subscribe((value) => {
      this.value = value;
      this.updateViewBox();
      this.emitChanges();
    });
  }

  writeValue(value: string): void {
    if (value) {
      this.value = value;
      this.valueControl.setValue(value.toString());
      this.updateViewBox();
    }
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.valueControl.disable();
    } else {
      this.valueControl.enable();
    }
  }

  private updateViewBox(): void {
    let valueWidth =
      [''].includes(this.value.toString()) && !this.useTextInput
        ? 0
        : Math.max(
            40,
            MathUtils.getTextWidth(this.value.toString(), {
              size: this.fontSize,
              family: this.fontFamily,
              weight: this.fontWeight,
            }),
          );

    if (this.useTextInput) {
      valueWidth += 20;
    } else {
      valueWidth += 20;
    }

    const height = this.fontSize * 2 + this.fontSize / 14;

    this._setViewBox(valueWidth, height);
  }

  emitChanges() {
    this.onChange(this.value.toString());
  }
}
